import React, { useState } from "react";
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";

const RangeSlider = (props) => {
  const [SelectedRange, setSelectedRange] = useState([
    props.MinValue,
    props.MaxValue,
  ]);

  const handleRangeChange = (Range) => {
    setSelectedRange(Range);
    props.UpdateCandidates();
  };

  return (
    <div className="range-slider-wrapper">
      <div id="yoe-min" className="yoe-range">
        {SelectedRange[0]}
      </div>
      <p className="slider-label">Years of experience</p>
      <Range
        step={1}
        min={props.MinValue}
        defaultValue={[props.MinValue, props.MaxValue]}
        max={props.MaxValue}
        onChange={(Range) => handleRangeChange(Range)}
      />
      <div id="yoe-max" className="yoe-range">
        {SelectedRange[1]}
      </div>
    </div>
  );
};

export default RangeSlider;
